import { useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../api";

export const ChangePassword = () => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (next !== confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated — use it next time you sign in");
      setCur(""); setNext(""); setConfirm("");
    } catch (e) { toast.error(fmtErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-2" data-testid="change-password-form">
      <input data-testid="cp-current" type="password" autoComplete="current-password" className="field-input w-full"
        placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} />
      <input data-testid="cp-new" type="password" autoComplete="new-password" className="field-input w-full"
        placeholder="New password (8+ chars)" value={next} onChange={(e) => setNext(e.target.value)} />
      <input data-testid="cp-confirm" type="password" autoComplete="new-password" className="field-input w-full"
        placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
      <button data-testid="cp-save" onClick={save} disabled={busy || !cur || next.length < 8 || next !== confirm}
        className="h-12 w-full rounded-md bg-primary text-sm font-bold text-primary-foreground disabled:opacity-40">Change password</button>
    </div>
  );
};
